/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';

/**
 * 
 * @export
 * @interface CreateSoftwareDto
 */
export interface CreateSoftwareDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    description?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateSoftwareDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateSoftwareDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSoftwareDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSoftwareDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateSoftwareDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateSoftwareDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    $type?: CreateSoftwareDtoTypeEnum;
}


/**
 * @export
 */
export const CreateSoftwareDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsCreateSoftwareDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateSoftwareDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateSoftwareDtoTypeEnum = typeof CreateSoftwareDtoTypeEnum[keyof typeof CreateSoftwareDtoTypeEnum];



/**
 * Check if a given object implements the CreateSoftwareDto interface.
 */
export function instanceOfCreateSoftwareDto(value?: unknown): value is CreateSoftwareDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateSoftwareDtoTypeEnum)[0];
}

export function CreateSoftwareDtoFromJSON(json: any): CreateSoftwareDto {
    return CreateSoftwareDtoFromJSONTyped(json, false);
}

export function CreateSoftwareDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSoftwareDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'version': json['version'] == null ? undefined : json['version'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateSoftwareDtoToJSON(value?: CreateSoftwareDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isAvailable': value['isAvailable'],
        'isArchived': value['isArchived'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'typeSpecification': value['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryToJSON(value['subCategory']),
        'version': value['version'],
        '$type': value['$type'],
    });
}

